/**
 *  爱车商App协议
 */
import util from '../../utils/util';
import eventBus from '@/services/eventBus.service';
export default class VRICSAppService {
  constructor() {
    this.runEncrysales();
    this.runGetPhoneBrand();
    this.runIsOpenSpeaker();
  }
  runEncrysales() {
    const self = this;
    this.getEncrysalesPromise = util.generatorPromise();
    this.getIcsAppUserInfoCallBackName =
      'getIcsAppUserInfo' + new Date().getTime();
    this.getIcsAppUserInfo = window[this.getIcsAppUserInfoCallBackName] = (
      data,
    ) => {
      self.getEncrysalesPromise.resolve(data);
      delete window[this.getIcsAppUserInfoCallBackName];
    };
  }
  runGetPhoneBrand() {
    const self = this;
    this.getPhoneBrandPromise = util.generatorPromise();
    this.getPhoneBrandCallBackName = 'getPhoneBrand' + new Date().getTime();
    this.getPhoneBrandInfo = window[this.getPhoneBrandCallBackName] = (
      data,
    ) => {
      self.getPhoneBrandPromise.resolve(data);
      delete window[this.getPhoneBrandCallBackName];
    };
  }
  /**
   *  i车商App_获取登录用户数据
   *  wiki地址： http://wiki.corpautohome.com/pages/viewpage.action?pageId=98780050
   *  需要将获取到的加密账号信息（encrysalesid）和_appid 作为参数传给服务端接口
   */
  getEncrysales() {
    if (window.ICSJavascriptBridge) {
      window.ICSJavascriptBridge.invoke(
        'icsGetUserInfo',
        JSON.stringify({ callback: this.getIcsAppUserInfoCallBackName }),
      );
    } else {
      this.getIcsAppUserInfo({ encrysalesid: '' });
    }
    return this.getEncrysalesPromise;
  }
  /**
   *  ICSAPP_挂断语音/视频通话
   *  wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=198159267
   */
  hangUpIcs() {
    window.ICSJavascriptBridge &&
      window.ICSJavascriptBridge.invoke('icsHangUpMediaCall', '');
  }
  /**
   *  ICSAPP_返回键js交互
   *  wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=88585857
   */
  appClose() {
    window.ICSJavascriptBridge &&
      window.ICSJavascriptBridge.invoke('backExit', '');
  }
  /**
   *  ICSAPP_返回键js交互
   *  wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=88585857
   */
  appBack() {
    window.ICSJavascriptBridge &&
      window.ICSJavascriptBridge.invoke('backNative', '');
  }
  /**
   *  ICSAPP_I车商-打开手机系统设置
   *  wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=217187602
   */
  icsOpenSetting(action) {
    window.ICSJavascriptBridge &&
      window.ICSJavascriptBridge.invoke('icsOpenSetting', action.toString());
  }
  /**
   * I车商-获取当前设备品牌
   * http://wiki.corpautohome.com/pages/viewpage.action?pageId=217186465
   * @returns 小米：MIUI,华为：EMUI (目前只接收这两种品牌)
   */
  icsInvokeGetPhoneBrand() {
    if (window.ICSJavascriptBridge) {
      window.ICSJavascriptBridge.invoke(
        'icsInvokeGetPhoneBrand',
        this.getPhoneBrandCallBackName,
      );
    } else {
      this.getPhoneBrandInfo('');
    }
    return this.getPhoneBrandPromise;
  }
  /**
   *  ICSAPP_-获取声网SDK回传的Audio状态
   *  wiki地址 http://wiki.corpautohome.com/pages/viewpage.action?pageId=232240270
   */
  runIsOpenSpeaker() {
    this.getIsOpenSpeakerCallBackName =
      'getsSpeakerInfo' + new Date().getTime();
    window[this.getIsOpenSpeakerCallBackName] = (data) => {
      console.log({
        'ICSAPP_-获取声网SDK': data,
      });
      eventBus.$emit('runIsOpenSpeaker', data);
    };
  }
  isOpenSpeaker() {
    if (window.ICSJavascriptBridge) {
      window.ICSJavascriptBridge.invoke(
        'getAgoraRtcEventState',
        JSON.stringify({ callback: this.getIsOpenSpeakerCallBackName }),
      );
    }
  }
  /**
   * VR看车-H5声网SDK控制扬声器
   * wiki地址 http://wiki.corpautohome.com/pages/viewpage.action?pageId=232240485
   */
  switchSpeaker(isOpen) {
    const isOpenArgs = JSON.stringify({ phoneSpeaker: isOpen });
    window.ICSJavascriptBridge &&
      window.ICSJavascriptBridge.invoke('switchPhoneSpeaker', isOpenArgs);
  }
  /**
   * i车商App_H5设置新的WebView界面打开
   * https://zhishi.autohome.com.cn/home/teamplace/file?targetId=hAVFNLAZfc
   * 参数 args ： “{'title': 'xxx',     'url': 'http...'， 'showNaviBar':  1}”
       title 导航栏title 如果隐藏导航栏，该参数可以不填 
       url  页面地址 必填  
       showNaviBar  是否展示导航栏  1 展示 0不展示  
   */
  icsSetNewWebView(args) {
    window.ICSJavascriptBridge &&
      window.ICSJavascriptBridge.invoke('icsSetNewWebView', args);
  }
}
